import React from "react";
import { Box, Typography } from "@mui/material";

// Presentational rows for the Third-Party Sharing debug drawer. Not localized on purpose:
// developer-only content behind DEBUG_DRAWER_FLAG.

export const Row: React.FC<{ label: string; value: React.ReactNode; color?: string }> = ({
  label,
  value,
  color,
}) => (
  <Box display="flex" justifyContent="space-between" gap={2}>
    <Typography variant="prose-sm" color="text.secondary" sx={{ wordBreak: "break-all" }}>
      {label}
    </Typography>
    <Typography
      variant="prose-sm"
      color={color}
      sx={{ fontFamily: "monospace", textAlign: "right", wordBreak: "break-all" }}
    >
      {value}
    </Typography>
  </Box>
);
